import { Box, Icon, Stack, Typography } from '@mui/material';
import { PlusIcon } from '@schooly/style';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface AddFamilyMemberButtonProps {
  textId: string;
  onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  testId?: string;
}

export const AddFamilyMemberButton: React.FC<AddFamilyMemberButtonProps> = ({
  textId,
  onClick,
  testId,
}) => (
  <Box>
    <Box onClick={onClick} display="inline-block" data-test-id={testId}>
      <Stack
        direction="row"
        alignItems="center"
        gap={1.5}
        sx={{
          cursor: 'pointer',
          color: (theme) => theme.palette.primary.main,
        }}
      >
        <Icon sx={{ display: 'flex' }}>
          <PlusIcon />
        </Icon>
        <Typography variant="h3">
          <FormattedMessage id={textId} />
        </Typography>
      </Stack>
    </Box>
  </Box>
);
